<template>
  <input class='controls map-search' type='text' placeholder='Search' ref="mapSearch">
</template>

<script>
export default {
  name: "compset-search",
  methods: {
    initSearch(google, map) {
      this.searchBox = new google.maps.places.SearchBox(this.$refs.mapSearch);

      map.addListener("bounds_changed", () => {
        this.searchBox.setBounds(map.getBounds());
      });

      this.searchBox.addListener("places_changed", this.onNewSearch);
    },
    onNewSearch() {
      this.$emit("new-search", this.searchBox.getPlaces());
    },
  }
};
</script>

<style scoped>
.map-search {
  background-color: rgba(0, 0, 0, 0.1);
  padding: 0.5rem;
  border-radius: 4px;
  width: 100%;
  outline-color: rgba(0, 0, 0, 0.2);
}
</style>
